import { Presets, type ReactPlugin } from 'rete-react-plugin'
import { ClassicPreset } from 'rete'
import { type JSXElementConstructor } from 'react'
import { type AcceptComponent } from 'rete-react-plugin/_types/presets/classic/utility-types'
import { PipelineEditorCustomButton } from '../components/PipelineEditorCustomButton.tsx'
import { PipelineEditorNodeContainer } from '../components/PipelineEditorNodeContainer.tsx'
import { PipelineEditorConnection } from '../components/PipelineEditorConnection.tsx'
import { ButtonControl } from './controls.tsx'
import { type AreaExtra, type Schemes } from './types.ts'

export const setupRenderer = (render: ReactPlugin<Schemes, AreaExtra>) => {
  render.addPreset(
    Presets.classic.setup({
      customize: {
        control: (data): AcceptComponent<(typeof data)['payload']> | null => {
          if (data.payload instanceof ClassicPreset.InputControl) {
            return Presets.classic.Control as JSXElementConstructor<{ data: ClassicPreset.Control }>
          }

          if (data.payload instanceof ButtonControl) {
            return PipelineEditorCustomButton as JSXElementConstructor<{
              data: ClassicPreset.Control
            }>
          }

          return null
        },
        node() {
          return PipelineEditorNodeContainer
        },
        socket() {
          return Presets.classic.Socket
        },
        connection() {
          return PipelineEditorConnection
        },
      },
    })
  )
}
